// EmberDivider — pure 2px animated blue ember line, no particles

const GRADIENT = 'linear-gradient(120deg, #050a10 0%, #0a1828 6%, #0d2035 12%, #1a3a5c 18%, #3a7ab8 22%, #5b9fd4 25%, #3a7ab8 28%, #0d2035 34%, #050a10 44%, #080e18 54%, #0d2035 62%, #1a3a5c 68%, #3a7ab8 71%, #5b9fd4 73%, #3a7ab8 75%, #0d2035 80%, #050a10 88%, #080e18 94%, #050a10 100%)';

export default function EmberDivider() {
  return (
    <div
      className="w-full"
      style={{
        height: '2px',
        background: GRADIENT,
        backgroundSize: '300% 100%',
        animation: 'water-flow 24s linear infinite',
        opacity: 0.85,
      }}
    />
  );
}
